import { Menu, Item, Submenu } from 'react-contexify';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  setSelectedTool,
  alignElement
} from '../../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import 'react-contexify/dist/ReactContexify.min.css';
import * as Constants from '../../../utilities/constants/Constants';
import { string } from '../../../localization';
import { Icons } from '../../../utilities';

// create your menu first
class ContextualMenu extends Component {
  state = {
    alignToolOptions: []
  };

  componentDidMount() {
    this.setState({
      alignToolOptions: this.getAlignOptions()
    });
  }

  componentDidUpdate(prevProps) {
    const { activeObject, language } = this.props;
    if (
      prevProps.activeObject != activeObject ||
      prevProps.language != language
    ) {
      this.setState({
        alignToolOptions: this.getAlignOptions()
      });
    }
  }

  getAlignOptions = () => [
    {
      alt: string.ALIGN_LEFT_KEY,
      icon_path: Icons.alignLeftDefault,
      highlight_path: Icons.alignLeftHover,
      id: Constants.ALIGN_TOOL_KEY.ALIGN_LEFT
    },
    {
      alt: string.ALIGN_CENTER_KEY,
      icon_path: Icons.alignCenterDefault,
      highlight_path: Icons.alignCenterHover,
      id: Constants.ALIGN_TOOL_KEY.ALIGN_CENTER
    },
    {
      alt: string.ALIGN_RIGHT_KEY,
      icon_path: Icons.alignRightDefault,
      highlight_path: Icons.alignRightHover,
      id: Constants.ALIGN_TOOL_KEY.ALIGN_RIGHT
    },
    {
      alt: string.ALIGN_TOP_KEY,
      icon_path: Icons.alignTopDefault,
      highlight_path: Icons.alignTopHover,
      id: Constants.ALIGN_TOOL_KEY.ALIGN_TOP
    },
    {
      alt: string.ALIGN_MIDDLE_KEY,
      icon_path: Icons.alignMiddleDefault,
      highlight_path: Icons.alignMiddleHover,
      id: Constants.ALIGN_TOOL_KEY.ALIGN_MIDDLE
    },
    {
      alt: string.ALIGN_BOTTOM_KEY,
      icon_path: Icons.alignBottomDefault,
      highlight_path: Icons.alignBottomHover,
      id: Constants.ALIGN_TOOL_KEY.ALIGN_BOTTOM
    }
  ];

  contextualItemClicked = item => {
    const { dispatchers, activeObject, wallCanvas } = this.props;
    if (activeObject) {
      item.onclick(activeObject, wallCanvas, item);
      dispatchers.setSelectedTool(item);
    }
  };

  isItemDisabled = item => item.state === Constants.DISABLED_STATE;

  render() {
    const { filteredTools, activeObject, wallCanvas, dispatchers } = this.props;
    const { alignToolOptions } = this.state;
    if (filteredTools && activeObject) {
      return (
        <Menu
          id='menu_id'
          style={{
            minWidth: '76px',
            fontSize: '14px',
            paddingTop: '1px',
            paddingBottom: '1px',
            fontFamily: 'HPSimplifiedLight, Arial, sans-serif',
            color: 'black'
          }}
        >
          {filteredTools.map(tool => (
            <div key={tool.id}>
              {tool.name === string.ALIGN_KEY ? (
                <Submenu
                  label={tool.name}
                  style={{
                    minWidth: '76px',
                    fontSize: '14px',
                    paddingTop: '1px',
                    paddingBottom: '1px',

                    fontFamily: 'HPSimplifiedLight, Arial, sans-serif',
                    color: 'black'
                  }}
                  disabled={this.isItemDisabled(tool)}
                >
                  {alignToolOptions.map(subTool => (
                    <Item
                      style={{
                        paddingTop: '1px',
                        paddingBottom: '1px'
                      }}
                      onClick={() =>
                        dispatchers.alignElement(subTool.id, wallCanvas)
                      }
                      key={subTool.id}
                    >
                      {subTool.alt}
                    </Item>
                  ))}
                </Submenu>
              ) : (
                <Item
                  style={{
                    paddingTop: '1px',
                    paddingBottom: '1px'
                  }}
                  onClick={() => this.contextualItemClicked(tool)}
                  disabled={this.isItemDisabled(tool)}
                >
                  {tool.name}
                </Item>
              )}
            </div>
          ))}
        </Menu>
      );
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    wallCanvas: state.fabricCanvas.wallCanvas,
    activeObject: state.fabricCanvas.activeObject,
    filteredTools: state.fabricCanvas.filteredTools,
    language: state.home.language
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      setSelectedTool: bindActionCreators(setSelectedTool, dispatch),
      alignElement: bindActionCreators(alignElement, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContextualMenu);
